import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import Alert from '@common/components/Alert';

const AlertMessages = forwardRef(
  ({ errorMessage, successMessage, onAlertClose }, ref) => (
    <>
      {errorMessage && (
        <Alert
          variant="error"
          onClose={() => onAlertClose('friendlyError')}
          ref={ref}
        >
          {errorMessage}
        </Alert>
      )}
      {successMessage && (
        <Alert
          variant="success"
          onClose={() => onAlertClose('friendlySuccess')}
          ref={ref}
        >
          {successMessage}
        </Alert>
      )}
    </>
  ),
);

AlertMessages.propTypes = {
  errorMessage: PropTypes.string,
  successMessage: PropTypes.string,
  onAlertClose: PropTypes.func.isRequired,
};

AlertMessages.defaultProps = {
  errorMessage: null,
  successMessage: null,
};

AlertMessages.displayName = 'AlertMessages';

export default AlertMessages;
